import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import Subscribe from '@/pages/billing/Subscribe';

/**
 * @param {boolean} skipPlanGate  never show the pricing popup here — the admin
 *   console (/adminwemanage) has its own admin gate and must stay reachable
 *   whatever the signed-in account's own billing state is.
 */
export default function ProtectedRoute({ children, skipPlanGate = false }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const needsPayment = useAuthStore((s) => !!s.user?.needs_payment);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  /*
   * A new account that hasn't picked a plan yet gets the pricing popup
   * (14 days free on a WeManage package) in place of whatever it asked for —
   * right after email confirmation, Google or Facebook sign-in, or any later
   * sign-in until it's done. The server enforces the same rule (402
   * payment_required), so this is the courtesy, not the control.
   */
  if (needsPayment && !skipPlanGate) {
    return <Subscribe gate />;
  }

  return children;
}
